export const CREATE_WHATSAPP_PLAN  = 'CREATE_WHATSAPP_PLAN';
export const GET_WHATSAPP_PLAN  = 'GET_WHATSAPP_PLAN';
export const WHATSAPP_PLAN_REQUEST  = 'WHATSAPP_PLAN_REQUEST';
export const DELETE_WHATSAPP_PLAN  = 'DELETE_WHATSAPP_PLAN';
export const UPDATE_WHATSAPP_PLAN  = 'UPDATE_WHATSAPP_PLAN';
export const WHATSAPP_PLAN_REQUEST_FAILURE  = 'WHATSAPP_PLAN_REQUEST_FAILURE';